import { createFetch } from '@vueuse/core';
import { useIframeDetection } from '@/composables/useIframeDetection';

// Fonction pour obtenir l'URL de l'API avec fallback
function getApiUrl(): string {
    const backendUrl = 'http://91.108.184.57';

    if (typeof window !== 'undefined' && window.env && window.env.VITE_BACK_URL) {
        let apiUrl = window.env.VITE_BACK_URL;
        if (!apiUrl.startsWith('http://') && !apiUrl.startsWith('https://')) {
            apiUrl = `https://${apiUrl}`;
        }
        return apiUrl;
    }

    return backendUrl;
}

// Initialiser la détection d'iframe
const { isInIframe, getOriginUrl } = useIframeDetection();

export const useFetchInstance = createFetch({
    baseUrl: getApiUrl(),
    combination: 'chain',
    options: {
        beforeFetch({ options }) {
            const originUrl = getOriginUrl();
            options.headers = {
                ...options.headers,
                originUrl: originUrl
            };
            return { options };
        }
    }
});
